<template>
  <custom-callout
    :has-toggle="false"
    border-color="gray"
    :class-main="isMobile ? 'p-2' : 'pb-3'"
    class="mt-2"
  >
    <div class="row custom-row">
      <div class="col-12 col-xl my-2 my-xl-0">
        <div
          :class="{
            'divider-horizontal': !isMobile,
            'divider-vertical': isMobile,
          }"
        >
          <span>Tipo de Escuela:</span>
          <div
            class="regular text-black"
            :class="{
              'text-title': !isMobile,
              'text-title-mobile': isMobile,
            }"
          >
            {{ item.type }}
          </div>
        </div>
      </div>
      <div class="col-12 col-xl-1 my-2 my-xl-0">
        <span>Número de Medicaid:</span>
        <div
          class="regular text-black"
          :class="{
            'text-title': !isMobile,
            'text-title-mobile': isMobile,
          }"
        >
          {{ item.nationalIdentifier | empty }}
        </div>
      </div>
      <div class="col-12 col-xl-3 my-2 my-xl-0">
        <span
          :class="{
            'text-title': !isMobile,
            'text-title-mobile': isMobile,
          }"
        >
          Nombre de Escuela:
        </span>
        <div
          class="regular text-black"
          :class="{
            'text-title': !isMobile,
            'text-title-mobile': isMobile,
          }"
        >
          <strong>{{ item.code }}</strong>
          - {{ item.name }}
        </div>
        <div v-show="item.address" class="mt-2">
          <div
            class="regular"
            :class="{
              'text-title': !isMobile,
              'text-title-mobile': isMobile,
              'mt-3': isMobile,
            }"
          >
            <span class="fa-stack force-orange">
              <i
                :class="[
                  'far',
                  'fa-map-marker-alt',
                  {
                    'fa-stack-1x': !isMobile,
                    'fa-stack-mobile': isMobile,
                  },
                ]"
              />
            </span>
            {{ item.address }}
          </div>
        </div>
      </div>
      <div class="col-12 col-xl my-2 my-xl-0">
        <span>Creado:</span>
        <div
          class="regular text-black"
          :class="{
            'text-title': !isMobile,
            'text-title-mobile': isMobile,
          }"
        >
          {{ item.createdByFullName }}
        </div>
        <div
          class="regular text-black"
          :class="{
            'text-title': !isMobile,
            'text-title-mobile': isMobile,
          }"
        >
          {{ formatDate(item.createdDate) }}
        </div>
      </div>
      <div class="col-12 col-xl my-2 my-xl-0">
        <span>Modificado:</span>
        <div
          class="regular text-black"
          :class="{
            'text-title': !isMobile,
            'text-title-mobile': isMobile,
          }"
        >
          {{ item.modifyByFullName }}
        </div>
        <div
          class="regular text-black"
          :class="{
            'text-title': !isMobile,
            'text-title-mobile': isMobile,
          }"
        >
          {{ formatDate(item.modifydDate) }}
        </div>
      </div>
      <div
        class="col-12 col-xl d-flex align-items-center justify-content-center justify-content-xl-start my-2 my-xl-0"
      >
        <badge
          v-if="[true, false].includes(item.lastCertified)"
          :value="item.lastCertified"
          text="Certificada"
        />
      </div>
      <div
        class="col-12 col-xl-1 d-flex align-items-center justify-content-center justify-content-xl-start my-2 my-xl-0"
      >
        <span>
          <span
            :class="[
              'badge badges',
              getBadgeClass(item.statusDescription),
              {
                'text-title': isMobile,
                'mt-3': isMobile,
              },
            ]"
          >
            {{ item.statusDescription }}
          </span>
        </span>
      </div>
      <div
        class="
          col-12 col-xl-auto d-flex align-items-center justify-content-center justify-content-xl-end my-2 my-xl-0
        "
      >
        <ActionButton
          :class="{
            'btn-full mt-3': isMobile,
          }"
          i="fas fa-file-import pr-1"
          variant="outline-success btn-transparent"
          @click="editSchool(item.id)"
        >
          Entrar
        </ActionButton>
      </div>
    </div>
  </custom-callout>
</template>

<script>
import CustomCallout from 'custom-callout';
import ActionButton from '@/components/common/ActionButton';
import Badge from '@/components/common/Badge';

import moment from 'moment';

const EDIT_SCHOOL_ROUTE_NAME = 'AddEditSchool';

export default {
  name: 'ResultRow',
  components: {
    CustomCallout,
    ActionButton,
    Badge,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({}),
  computed: {
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
  },
  methods: {
    getBadgeClass(status) {
      switch (status) {
        case 'Activa':
          return 'badge-active';
        case 'Inactiva':
          return 'badge-inactive';
        default:
          return '';
      }
    },
    formatDate(date) {
      if (date == null) return;
      return moment(date)
        .locale('es')
        .format('DD/MMM/YYYY')
        .replace('.', '');
    },
    editSchool(schoolId) {
      this.$router.push({
        name: EDIT_SCHOOL_ROUTE_NAME,
        params: {
          id: schoolId,
        },
      });
    },
  },
};
</script>

<style scoped>
.force-orange {
  color: #ff7058;
}

.divider-horizontal {
  border-right: 1px solid #e2e2e2;
  height: 100%;
}

.divider-vertical {
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e2e2e2;
}

.text-title {
  font-size: 14px !important;
}

.badges.text-title {
  height: 32px;
}

.text-title-mobile {
  font-size: 12px;
}

.fa-stack {
  width: 20px;
}

.fa-stack-mobile {
  font-size: 21px;
}

.btn-full {
  width: 100%;
}

span {
  color: #727272;
  font-size: 14px;
  font-weight: 400;
}

/************ CUSTOM BADGES *************/
.badges {
  color: black;
  font-size: 16px;
  font-weight: bold;
  width: 86px;
  height: 32px;
  line-height: 20px;
  border-radius: 18px;
  padding: 5px;
}
.badge-active {
  background: #a3e5b3;
}
.badge-inactive {
  background: #d5b89a;
}
.btn-transparent {
  background: transparent;
}

::v-deep .collaut-container {
  padding: 15px 20px;
}
.custom-row {
  word-break: normal;
  overflow-wrap: normal;
}
@media (max-width: 1199.98px) {
  .custom-row {
    justify-content: center;
    text-align: center;
  }
}
</style>
